<template>
  <div v-if="templateType === 'chip'">
    <v-chip 
      v-if="roleKey === '0'" 
      color="cyan" dark x-small
    >{{ "lng_dealer_txt" | translate }}</v-chip>
    <v-chip 
      v-else-if="roleKey === '1'" 
      color="pink" dark x-small
    >{{ "lng_end_user_txt" | translate }}</v-chip>
    <!-- <v-chip 
      v-else-if="roleKey === '2'" 
      color="brown" dark x-small
    >{{ "lng_multiuser_txt" | translate }}</v-chip> -->
    <v-chip 
      v-else-if="roleKey === '3'" 
      color="green" dark x-small
    >{{ "lng_admin_txt" | translate }}</v-chip>
    <v-chip 
      v-else-if="roleKey === '10'" 
      color="#90EE90" x-small
    >{{ "lng_dealer_txt" | translate }}</v-chip>
    <v-chip
      v-else-if="roleKey === '11'" 
      color="blue" x-small
    >{{ "lng_service_partner_txt" | translate }}</v-chip>
    <v-chip
      v-else-if="roleKey === '12'" 
      color="green" x-small
    >{{ "lng_dealer_service_partner_txt" | translate }}</v-chip>
    <v-chip 
      v-if="roleKey === '5'" 
      color="teal" dark x-small
    >{{ "lng_dealer_and_solar_txt" | translate }}</v-chip>
    <v-chip 
      v-if="roleKey === '6'" 
      color="yellow" dark x-small
    >{{ "lng_solar_dealer_txt" | translate }}</v-chip>
    <v-chip 
      v-if="roleKey === '7'" 
      color="orange" dark x-small
    >{{ "lng_service_partner_solar_txt" | translate }}</v-chip>
    <v-chip 
      v-if="roleKey === '8'" 
      color="#FF00FF" dark x-small
    >{{ "lng_dealer_service_partner_solar_txt" | translate }}</v-chip>
    <v-chip 
      v-if="roleKey === '9'" 
      color="#00008B" dark x-small
    >{{ "lng_wholesaler_txt" | translate }}</v-chip>
  </div>
  
  <div v-else-if="templateType === 'badge'">
    <v-badge
      v-if="roleKey === '0'" 
      color="cyan" content="d"
    ></v-badge>
    <v-badge
      v-else-if="roleKey === '1'" 
      color="pink" content="u"
    ></v-badge>
    <v-badge
      v-else-if="roleKey === '2'" 
      color="brown" content="m"
    ></v-badge>
    <v-badge
      v-else-if="roleKey === '3'" 
      color="green" content="a"
    ></v-badge>
    <v-badge
      v-else-if="roleKey === '10'" 
      color="#90EE90" content="a"
    ></v-badge>
    <v-badge dark
      v-else-if="roleKey === '11'" 
      color="blue" content="a"
    ></v-badge>
    <v-badge
      v-else-if="roleKey === '12'" 
      color="green" content="a"
    ></v-badge>
    <v-badge 
      v-else-if="roleKey === '5'" 
      color="teal" dark content="a"
    ></v-badge>
    <v-badge 
      v-else-if="roleKey === '6'" 
      color="yellow" dark content="a"
    ></v-badge>
    <v-badge 
      v-else-if="roleKey === '7'" 
      color="orange" dark content="a"
    ></v-badge>
    <v-badge 
      v-else-if="roleKey === '8'" 
      color="#FF00FF" dark content="a"
    ></v-badge>
    <v-badge 
      v-else-if="roleKey === '9'" 
      color="#00008B" dark content="a"
    ></v-badge>
  </div>  
</template>

<script>
export default {
  name: "UserRoles",
  props:{
    roleKey: {
      type: String,
      default: ""
    },
    templateType: {
      type: String,
      default: "chip"
    }
  }
}
</script>

<!-- 
Dealer                                  = 10  = light green (#90EE90)
Service Partner                         = 11  = Blue 
Dealer and Service Partner              = 12  = green
Dealer and Solar                        = 5.  = teal 
Solar Dealer                            = 6.  = yellow 
Service Partner and Solar               = 7.  = Orange 
Dealer, Service Partner and Solar       = 8   = Magenta
Wholesaler                              = 9   = Dark blue(#00008B) 
-->
